import comp from "./CompactUIFooter";
export default comp;
